// Base URL for Supabase Storage - dynamically constructed from environment variable
const getStorageUrl = () => {
  const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
  if (!supabaseUrl) {
    console.error('REACT_APP_SUPABASE_URL is not defined');
    return '';
  }
  return `${supabaseUrl}/storage/v1/object/public/course-images`;
};

const STORAGE_URL = getStorageUrl();

/**
 * Ensures the filename has a .png extension if no extension is present
 */
function ensurePngExtension(filename: string): string {
  return filename.includes('.') ? filename : `${filename}.png`;
}

/**
 * Transforms custom [IMAGE:...] tags into markdown image syntax
 * 
 * Supported formats:
 * - [IMAGE:filename] -> Uses filename as alt text
 * - [IMAGE:filename alt text] -> Uses provided alt text (space separator)
 * - [IMAGE:filename|alt text] -> Alternative syntax with pipe separator
 * 
 * Note: Automatically appends .png if no file extension is provided
 */
export function transformCustomImageTags(content: string): string {
  // First handle the pipe syntax [IMAGE:file|alt text]
  let transformed = content.replace(
    /\[IMAGE:([^\]|]+)\|([^\]]*)\]/g, 
    (match, filename, altText) => {
      const cleanFilename = ensurePngExtension(filename.trim());
      const cleanAltText = altText.trim() || cleanFilename.replace(/\.[^/.]+$/, '');
      return `![${cleanAltText}](${STORAGE_URL}/${cleanFilename})`;
    }
  );

  // Then handle the space syntax [IMAGE:file alt text]
  transformed = transformed.replace(
    /\[IMAGE:([^\s\]]+)(?:\s+([^\]]+))?\]/g,
    (match, filename, altText = '') => {
      const cleanFilename = ensurePngExtension(filename.trim());
      const cleanAltText = altText.trim() || cleanFilename.replace(/\.[^/.]+$/, '');
      return `![${cleanAltText}](${STORAGE_URL}/${cleanFilename})`;
    }
  );

  return transformed;
}
